module.exports = __webpack_public_path__ + "0ba5b7f127f40c33e7611c77dba2e945.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/logo-ministere.png
// module id = 468
// module chunks = 0